var mpApi,
    $loginForms,
    $logoutBtn,
    $apiBody
;

$(document).ready(function($) {

  /* Back off if mpapi not available */
  if(typeof MpApi === 'undefined') {
    return;
  }


  /* -----------------------------------
   | Get elements
   * ----------------------------------- */
  $loginForms   = $('.js-login-form');
  $logoutBtn   = $('.js-logout');
  $apiBody = $('body');

  /* -----------------------------------
   | Get mpApi Instance
   * ----------------------------------- */
  mpApi = new MpApi();

  $apiBody.on('click','.js-set-sso-check',function(){
    mpApi.forceSsoCheckOnNextRequest();
  });


  $logoutBtn.click(function(e) {
    mpApi.logout(function(){
      location.reload();
    }, function(e) {
      alert('Er is iets misgegaan');
    });
  });

  $loginForms.submit(function(e){
    e.preventDefault(); // Prevent default submit

    var $form = $(this);

    $form.removeClass('is-error is-loading');

    var formData = new FormData($form.get(0));

    if(formData.get('username') === "" || formData.get('password') === "") {
      $form.addClass('is-error');
      return;
    }

    $form.addClass('is-loading');

    mpApi.login(formData.get('username'), formData.get('password'), formData.get('remember'), function(user) {

      var urlParams = new URLSearchParams(window.location.search);
      var checkoutUrl = $form.data('checkouturl');

      var currHost = location.protocol + "//" + location.host;
      var referrer = document.referrer;
      var referrerIsSameHost = referrer.indexOf(currHost) === 0;

      if (urlParams.has('redirect_to_checkout') && checkoutUrl ) {
        //redirect to checkout
        window.location.href = checkoutUrl;

      } else if (referrerIsSameHost && window.history.length > 2) {
        // Vorige url alleen als het van myparcel afkomt
        window.history.back();
      } else {
        // Ga naar home url
        document.location.href="/";
      }

    }, function(err) {
      // Not logged in;
      $form.removeClass('is-loading');
      $form.addClass('is-error');
    })


  });

});

